import { apiFetch } from '@/lib/api/client';
import type { SurahView } from '@/features/quran/types';

/**
 * `GET /quran/surahs`. Global structural reference data (ADR-023) -
 * authenticated only, explicitly NOT tenant-scoped (`quran.routes.ts`'s own
 * doc comment: "readable by any authenticated role regardless of
 * organization").
 */
export async function listSurahs(): Promise<readonly SurahView[]> {
  return apiFetch<readonly SurahView[]>('/quran/surahs');
}
